module.exports = __webpack_public_path__ + "img/allergy-shellfish.607f1255.png";